import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import config from './aws-exports';
import Amplify from '@aws-amplify/core';
Amplify.configure({
    ...config,
    Analytics: { 
      disabled: true
    }
});
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
